var site = site || {};
site.GeneralErrorModal = (function () {
    //#region Private Variables

    /** @type {JQuery<HTMLElement>|null} */
    let $modal = null;
    /** @type {JQuery<HTMLElement>|null} */
    let $modalTitle = null;
    /** @type {JQuery<HTMLElement>|null} */
    let $modalBody = null;

    const callback = {
        resolve: null,
        reject: null,
    };

    //#endregion

    //#region Private Methods

    //#endregion

    //#region Public Methods

    const initialize = function () {
        $modal = $("#general-error-alert-message-modal");
        $modalTitle = $modal.find("#modal-title");
        $modalBody = $modal.find("#specific-error-message");

        $modal.modal({
            backdrop: true,
            keyboard: true,
            focus: false,
            show: true,
        });

        $modal.on("hidden.bs.modal", function () {
            callback.resolve();
            callback.resolve = null;
            callback.reject = null;
        });
    }

    /**
     * Opens the modal and returns a promise that resolves when the modal is closed.
     * @param {string} messageHtml 
     * @returns 
     */
    const open = function (messageHtml) {
        if (callback.resolve !== null && callback.reject !== null) {
            throw new Error("Previous error callback has not resolved.");
        }

        $modalBody.html(messageHtml);
        $modal.modal("show");

        return new Promise(function (resolve, reject) {
            callback.resolve = resolve;
            callback.reject = reject;
        });
    }

    //#endregion

    return {
        initialize,
        open
    }
})();